import React from 'react';
import { AiOutlineWhatsApp, AiOutlineMail, AiFillLinkedin } from 'react-icons/ai';
import { CiLocationOn } from 'react-icons/ci';




const Contact = () => {


    return (

        <div className=' text-gray-300 py-12' id="contact">
            <h1 className='text-2xl font-bold '>06.<span className='text-primary'>Contact_Me</span></h1>
            <h1 class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400 py-2">Any time you can message me. I am always ready to answer your question . </h1>









            <div className='grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mt-6'>

                <div class="card w-84  shadow-xl">
                    <figure class="pt-6">
                        <h1 className='contact-icon-design text-primary text-center'><CiLocationOn /></h1>

                    </figure>
                    <div class="card-body items-center text-center">
                        <h1 className='text-gray-300   text-1xl text-center'>Sylhet,Bangladesh</h1>

                    </div>
                </div>
                <div class="card w-84  shadow-xl">
                    <figure class="pt-6">
                        <h1 className='contact-icon-design text-primary text-center'><AiOutlineWhatsApp /></h1>

                    </figure>
                    <div class="card-body items-center text-center">
                        <h1 className='text-gray-300  text-1xl text-center'>+8801614853207</h1>

                    </div>
                </div>

                <a target="_blank" href="https://www.linkedin.com/in/IslamMozahidul/">
                    <div class="card w-84  shadow-xl">
                        <figure class="pt-6">
                            <h1 className='contact-icon-design text-primary text-center'><AiFillLinkedin /></h1>

                        </figure>
                        <div class="card-body items-center text-center">
                            <h1 className='text-gray-300  text-1xl text-center'>LinkedIn Message</h1>

                        </div>
                    </div></a>

                <a target="_blank" href="mozahidulislam1618@gmail.com">
                    <div class="card w-84  shadow-xl">
                        <figure class="pt-6">
                            <h1 className='contact-icon-design text-primary text-center'><AiOutlineMail /></h1>

                        </figure>
                        <div class="card-body items-center text-center">
                            <h1 className='text-gray-300   text-1xl text-center'>mozahidulislam1618@gmail.com</h1>

                        </div>
                    </div></a>














            </div>
        </div>

    );
};



export default Contact;